import { createApi } from "@reduxjs/toolkit/query/react";
import { axiosBaseQuery } from "../baseQuery";
import API_ENDPOINTS from "../../apiEndpoints";
import { setPdfStatus } from "../reducers/pdfStatusSlice.ts";

export const CreatePdfApi = createApi({
  reducerPath: "createPdfApi",
  baseQuery: axiosBaseQuery,
  endpoints: (builder) => ({
    createPdf: builder.mutation({
      query: ({ companyid, path, invoiceids, type, transactionid }) => ({
        url: API_ENDPOINTS.GENERATE_PDF_PDFKIT,
        method: "POST",
        data: {
          companyID: companyid,
          path,
          InvoiceIDS: [invoiceids],
          transactionIds: [transactionid],
          type,
        },
      }),
      async onQueryStarted({ path }, { dispatch, queryFulfilled }) {
        console.log("onQueryStarted", path);
        dispatch(setPdfStatus({ path, status: "pending" }));
        try {
          await queryFulfilled;
          console.log("onQueryStarted done", path);
          dispatch(setPdfStatus({ path, status: "ready" }));
        } catch {
          console.log("onQueryStarted failed", path);
          dispatch(setPdfStatus({ path, status: "ready" })); // Optional: use 'failed'
        }
      },
    }),
  }),
});

export const { useCreatePdfMutation } = CreatePdfApi;
